// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportSubscribeActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  var localizer = require('share/localization/Izenda.Localizer');

  const { curry, isNil, filter } = require('lodash/fp');

  var ReportSubscribeActions = compose(
    withHandlers({
      onSaveSubscription: curry(onSaveSubscription),
      onSave: function(props) {
        return onSave.bind(null, props);
      },
      setType: curry(setType),
      loadData: function(props) {
        return loadData.bind(null, props);
      }
    })
  );

  /**
   * Save subscription data.
   */
  function onSaveSubscription(props, subData) {
    // Update for report subscribe grid
    props.subscribedInstancesStore.model.updateSubscribedInstances(subData);

    // Save subcription if in report list mode
    // var reportListMode = !!props.onClose;
    // reportListMode &&
    onSave(props);
  }

  /**
   * Save subscription when add new.
   */
  function onSave(props, _) {
    var subscribedInstancesStore = props.subscribedInstancesStore;
    var reportStore=props.reportStore;
    
    reportStore &&  reportStore.alertDetails && reportStore.alertDetails.reset();

    // Update for report subscribe grid
    var loader = props.loader;
    loader.startLoading();
    return subscribedInstancesStore
      .saveInstances()
      .then(function(result) {
        if (result.success) {
          subscribedInstancesStore.loadInstances();

          reportStore &&  reportStore.alertDetails && reportStore.alertDetails.set({
            success: true,
            message: localizer.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED')
          });
        }
        return result;
      })
      .finally(loader.endLoading.bind(loader));
  }

  /**
   * Set subscribe type
   * @param {Object} properties
   * @param {Boolean} subscribe mode
   */
  function setType(props, isSubscribe) {
    var subscribedInstancesStore = props.subscribedInstancesStore;
    subscribedInstancesStore.model.setType(isSubscribe);
  }

  /**
   * Set subscribe type
   * @param {Object} properties
   * @param {Boolean} report list mode : load new data
   */
  function loadData(props, reportListMode) {
    var subscribedInstancesStore = props.subscribedInstancesStore;
    var reportId = props.reportId;

    if (!isNil(reportId)) {
      // Get data for edit case
      subscribedInstancesStore.updateReportId(reportId);
    }

    var instances = reportListMode
      ? []
      : filter(function(item) {
          return item.isSubscription === true;
        }, subscribedInstancesStore.model.subscribedInstances.toJS());

    subscribedInstancesStore.loadInstances(instances);
  }

  module.exports = ReportSubscribeActions;
})();



// WEBPACK FOOTER //
// ./ui/modules/Reports/ReportSubscribe/Izenda.ReportSubscribeActions.js